// В.2.f-2: «Последний довод» (liv_posledniy_dovod, legendary Действие).
// «Полностью исцеляет твоего Героя и всех твоих юнитов на поле».
//
// Без picker'а.
//
// Поведение: для Героя и каждого живого союзного юнита — healUnit с
// amount = max_hp - current_hp. Если уже на полном ХП — actualAmount=0,
// событие healed не эмитится (это норма). Триггеры on_heal (Ошибка
// эксперимента, Бьорк позже) срабатывают на каждое реальное лечение.

import { healUnit } from './heal.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_posledniy_dovod';
const LABEL = 'Последний довод';

registerImplementedAbility(CARD_ID, 'oneshot');

export function actionTargets(_state, _playerIdx) {
  return [];
}

export function resolve(state, playerIdx /*, target, opts */) {
  const me = state.players?.[playerIdx];
  if (!me) return { ok: true, skipped: true };
  state.log?.add(`✚ ${LABEL}: полное исцеление Героя и всех своих юнитов`);
  // Полное лечение Героя.
  if (me.hero && me.hero.hp > 0) {
    const need = Math.max(0, (me.hero.base?.hp ?? 0) - (me.hero.current?.hp ?? 0));
    if (need > 0) {
      healUnit(state, me.hero, need, { id: CARD_ID, name_ru: LABEL, type: 'action' });
    }
  }
  // Полное лечение всех живых союзных юнитов.
  const allies = me.unitsOnField().slice();
  for (const a of allies) {
    if (!a.isAlive()) continue;
    const need = Math.max(0, (a.base?.hp ?? 0) - (a.current?.hp ?? 0));
    if (need > 0) {
      healUnit(state, a, need, { id: CARD_ID, name_ru: LABEL, type: 'action' });
    }
  }
  return { ok: true };
}
